import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ApiUsagesDetail from "./APIUsages/APIUsagesDetail";

export default function DrmPfDetail() {
  const [tabValue, setTabValue] = useState<string | null>("api");
  const navigate = useNavigate();

  return (
    <div>
      <div className="sub-header">
        <ul className="uk-tab uk-margin">
          <li className="uk-active">
            <Link to="/drm_pf/api">利用料</Link>
          </li>
          <li>
            <Link to="/basic_info">基本情報</Link>
          </li>
          <li>
            <Link to="/drm_pf/info">DRM-PF</Link>
          </li>
          <li>
            <Link to="/ticket">DRM-Chat</Link>
          </li>
        </ul>
      </div>
      <div className="container">
        <ApiUsagesDetail />
      </div>
    </div>
  );
}
